import { iframeResizer } from "iframe-resizer";
import qs from "qs";

const createEmbed = (id, options) => {
  console.log("options", options);
  var iframe = document.createElement("iframe");
  iframe.scrolling = "no";
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.border = "none";
  iframe.style.opacity = "0";
  const selector = id.slice(0, 1) === "#" ? id : "#" + id;
  const div = document.querySelector(selector);
  div.appendChild(iframe);
  let hasResizedOnce = false;
  const url = process.env.URL ? process.env.URL : window.location.origin;
  iframe.src = `${url}?${qs.stringify(options)}`;
  iframe.onload = () => {
    iframeResizer(
      {
        log: false,
        heightCalculationMethod: "documentElementOffset",
        resizedCallback(x) {
          // Avoid render the first time with the wrong height.
          if (!hasResizedOnce) {
            iframe.style.opacity = "1";
            hasResizedOnce = true;
          }
        },
      },
      iframe
    );
  };
};

window._smuCreateEmbed = createEmbed;



// WEBPACK FOOTER //
// ./src/create-embed.js